import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { concatMap, map, mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ITransactionDefinition } from '@app/transaction-builder/model/transaction-definition.model';
import { EnvConfigService } from 'ngx-mat-esign360';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient, private envConfig: EnvConfigService) {}

  createTransaction(transactionDefinition: ITransactionDefinition): Observable<string> {
    return this.http
      .post<any>(`${this.envConfig.data.signServerUrl}/prepareTransaction`, transactionDefinition)
      .pipe(
        map((result) => {
          return result.data ? result.data : result.Data;
        })
      );
  }

  startTransaction(data: any): Observable<any> {
    return this.http.post(`${this.envConfig.data.signServerUrl}/startTransaction`, data);
  }

  createAndStartTransaction(transactionDefinition: ITransactionDefinition): Observable<any> {
    return this.createTransaction(transactionDefinition).pipe(
      mergeMap((data) => this.startTransaction(data))
    );
  }
}
